
import { createReducer } from 'reducers';
import { Map, List } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    SEARCH_USER_REQUESTED,
    SEARCH_USER_FAILED,
    SEARCH_USER_SUCCESSFUL,
    GET_COACH_APPLICATIONS_REQUESTED,
    GET_COACH_APPLICATIONS_SUCCESSFUL,
    GET_COACH_APPLICATIONS_FAILED,
    COACH_APPLICATION_UPGRADE_REQUESTED,
    COACH_APPLICATION_UPGRADE_FAILED,
    COACH_APPLICATION_UPGRADE_SUCCESSFUL,
    ERASE_CURRENT_USER_DATA,
    START_LOADER,
    STOP_LOADER,
    OVERRIDE_STUDENT_SUCCESSFUL,
    UPGRADE_STUDENT_SUCCESSFUL,
    STUDENT_EVALUATION_SUCCESSFUL,
    DELETE_COACH_SUCCESSFUL,
    ADD_COACH,
    MODIFY_COLLEGE,
    RESET_DELETE_COACH,
    RESET_ADD_COACH,
    RESET_STUDENT_VALUES,
    GET_COACHES_FROM_DB,
    ADD_COLLEGE_SUCCESSFUL,
    GET_STUDENTS_FOR_STUDENT_EXPLORER,
    DELETE_COACH_APPLICATION_SUCCESSFUL,
  RESET_STUDENT_DASHBOARD_SUCCESSFUL,
  START_ES_LOADER,
  STOP_ES_LOADER,
  // GET_ES_STUDENTS_FOR_STUDENT_EXPLORER,
  SEARCH_ES_USER_REQUESTED,
  SEARCH_ES_USER_FAILED,
  SEARCH_ES_USER_SUCCESSFUL,
} from './actionTypes';

export { SAProfilePage } from 'containers/Profile-view/redux';


export const initialState = Map({
  error: '',
  esError: '',
  success: false,
  isRequested: false,
  isLoading: false,
  isEsLoading: false,
  coachApplicationRequested: false,
  coachApplications: Map(),
  searchUserRequested: false,
  searchUserData: Map(),
  searchEsUserRequested: false,
  searchEsUserData: List(),
  applicationUpgradeRequested: false,
  upgradeInfo: false,
  overrideInfo: false,
  evaluatedInfo: false,
  coachDeleted: false,
  coachAdded: false,
  collegeAdded: false,
  collegeModified: false,
  coachesFromCollege: Map(),
  searchHappened: false,
  searchEsHappened: false,
  filterBasedStudents: List(),
  // filterBasedEsStudents: List(),
  filterBasedEsAtheletes: List(),
});

const updateCoachApplication = (id, state) => {
  let applications = state.get('coachApplications');
  const temp = applications.toJS();
  applications = temp;
  for(let i=0; i < applications.length; i++) { // eslint-disable-line
    if (applications[i].coach_id === id) {
      applications.splice(i, 1);
    }
  }
  return applications;
};

const getCuratedArrayFromElasticData = (data) => {
  const array = [];
  const temp = data.toJS();
  for (let i = 0; i < temp.length; i++) { // eslint-disable-line
    array.push(temp[i]._source); // eslint-disable-line
  }
  return array;
};

const handlers = {
  [SEARCH_USER_REQUESTED](state) {
    return state.merge({
      searchUserRequested: true,
      searchHappened: false,
      searchUserData: Map(),
      error: '',
    });
  },
  [SEARCH_USER_FAILED](state, action) {
    return state.merge({
      searchUserRequested: false,
      error: action.error,
    });
  },
  [SEARCH_USER_SUCCESSFUL](state, action) {
    return state.merge({
      searchUserRequested: false,
      searchHappened: true,
      searchUserData: action.data,
    });
  },
  [SEARCH_ES_USER_REQUESTED](state) {
    return state.merge({
      searchEsUserRequested: true,
      searchEsHappened: false,
      searchEsUserData: List(),
      esError: '',
    });
  },
  [SEARCH_ES_USER_FAILED](state, action) {
    return state.merge({
      searchEsUserRequested: false,
      esError: action.error,
    });
  },
  [SEARCH_ES_USER_SUCCESSFUL](state, action) {
    return state.merge({
      searchEsUserRequested: false,
      searchEsHappened: true,
      searchEsUserData: getCuratedArrayFromElasticData(action.data),
    });
  },
  [GET_COACH_APPLICATIONS_REQUESTED](state) {
    return state.merge({
      coachApplicationRequested: true,
    });
  },
  [GET_COACH_APPLICATIONS_SUCCESSFUL](state, action) {
    return state.merge({
      coachApplicationRequested: false,
      coachApplications: action.data,
    });
  },
  [GET_COACH_APPLICATIONS_FAILED](state) {
    return state.merge({
      coachApplicationRequested: false,
    });
  },
  [COACH_APPLICATION_UPGRADE_REQUESTED](state) {
    return state.merge({
      applicationUpgradeRequested: true,
    });
  },
  [COACH_APPLICATION_UPGRADE_FAILED](state) {
    return state.merge({
      applicationUpgradeRequested: false,
    });
  },
  [COACH_APPLICATION_UPGRADE_SUCCESSFUL](state) {
    return state.merge({
      applicationUpgradeRequested: false,
    });
  },
  [ERASE_CURRENT_USER_DATA](state) {
    return state.merge({
      searchUserRequested: false,
      searchHappened: false,
      applicationUpgradeRequested: false,
      upgradeInfo: false,
      overrideInfo: false,
      evaluatedInfo: false,
      coachDeleted: false,
      coachAdded: false,
      collegeAdded: false,
      collegeModified: false,
      searchUserData: Map(),
      searchEsUserData: Map(),
      dashboardReset: false,
    });
  },
  [START_LOADER](state) {
    return state.merge({
      isLoading: true,
      collegeAdded: false,
      dashboardReset: false,
    });
  },
  [STOP_LOADER](state) {
    return state.merge({
      isLoading: false,
    });
  },
  [UPGRADE_STUDENT_SUCCESSFUL](state) {
    return state.merge({
      isLoading: false,
      upgradeInfo: true,
    });
  },
  [OVERRIDE_STUDENT_SUCCESSFUL](state) {
    return state.merge({
      isLoading: false,
      overrideInfo: true,
    });
  },
  [STUDENT_EVALUATION_SUCCESSFUL](state) {
    return state.merge({
      isLoading: false,
      evaluatedInfo: true,
    });
  },
  [DELETE_COACH_SUCCESSFUL](state) {
    return state.merge({
      isLoading: false,
      coachDeleted: true,
    });
  },
  [ADD_COACH](state) {
    return state.merge({
      isLoading: false,
      coachAdded: true,
    });
  },
  [MODIFY_COLLEGE](state) {
    return state.merge({
      isLoading: false,
      collegeModified: true,
    });
  },
  [RESET_DELETE_COACH](state) {
    return state.merge({
      coachDeleted: false,
    });
  },
  [RESET_ADD_COACH](state) {
    return state.merge({
      coachAdded: false,
    });
  },
  [RESET_STUDENT_VALUES](state) {
    return state.merge({
      upgradeInfo: false,
      overrideInfo: false,
      evaluatedInfo: false,
    });
  },
  [GET_COACHES_FROM_DB](state, action) {
    return state.merge({
      coachesFromCollege: action.data,
      isLoading: false,
    });
  },
  [ADD_COLLEGE_SUCCESSFUL](state) {
    return state.merge({
      collegeAdded: true,
      isLoading: false,
    });
  },
  [DELETE_COACH_APPLICATION_SUCCESSFUL](state, action) {
    return state.merge({
      isLoading: false,
      coachApplications: updateCoachApplication(action.id, state),
    });
  },
  [GET_STUDENTS_FOR_STUDENT_EXPLORER](state, action) {
    return state.merge({
      filterBasedStudents: getCuratedArrayFromElasticData(action.data),
      isLoading: false,
    });
  },
  [RESET_STUDENT_DASHBOARD_SUCCESSFUL](state) {
    return state.merge({
      isLoading: false,
      dashboardReset: true,
    });
  },
  // [GET_ES_STUDENTS_FOR_STUDENT_EXPLORER](state, action) {
  //   return state.merge({
  //     filterBasedEsStudents: getCuratedArrayFromElasticData(action.data),
  //     // filterBasedEsStudents: action.data,
  //     isEsLoading: false,
  //   });
  // },
  [START_ES_LOADER](state) {
    return state.merge({
      isEsLoading: true,
      collegeAdded: false,
      dashboardReset: false,
    });
  },
  [STOP_ES_LOADER](state) {
    return state.merge({
      isEsLoading: false,
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      searchUserDataerror: false,
      success: false,
      isRequested: false,
      coachApplicationRequested: false,
      coachApplications: Map(),
      searchUserRequested: false,
      searchUserData: Map(),
      searchEsUserData: Map(),
      applicationUpgradeRequested: false,
      dashboardReset: false,
    });
  },
};

export const admin = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getCoachApplicationsRequested = state => state.admin.get('coachApplicationRequested');
const getCoachApplications = state => state.admin.get('coachApplications');
const getSearchUserRequested = state => state.admin.get('searchUserRequested');
const getSearchedUserData = state => state.admin.get('searchUserData');
const getSearchEsUserRequested = state => state.admin.get('searchEsUserRequested');
const getSearchedEsUserData = state => state.admin.get('searchEsUserData');
const getapplicationUpgradeRequested = state => state.admin.get('applicationUpgradeRequested');
const getOverrideInfo = state => state.admin.get('overrideInfo');
const getUpgradeInfo = state => state.admin.get('upgradeInfo');
const getEvaluatedInfo = state => state.admin.get('evaluatedInfo');
const getIsLoading = state => state.admin.get('isLoading');
const getIsEsLoading = state => state.admin.get('isEsLoading');
const getDeletedCoach = state => state.admin.get('coachDeleted');
const getCoachAdded = state => state.admin.get('coachAdded');
const getCollegeModified = state => state.admin.get('collegeModified');
const getCoachesFromCollege = state => state.admin.get('coachesFromCollege');
const getCollegeAdded = state => state.admin.get('collegeAdded');
const getSearchHappened = state => state.admin.get('searchHappened');
const getSearchEsHappened = state => state.admin.get('searchEsHappened');
const error = state => state.admin.get('error');
const esError = state => state.admin.get('esError');
const filterBasedStudents = state => state.admin.get('filterBasedStudents');
// const filterBasedEsStudents = state => state.admin.get('filterBasedEsStudents');
const getDashboardReset = state => state.admin.get('dashboardReset');

export const selector = createStructuredSelector({
  coachApplicationRequested: getCoachApplicationsRequested,
  coachApplications: getCoachApplications,
  searchUserRequested: getSearchUserRequested,
  searchUserData: getSearchedUserData,
  searchEsUserRequested: getSearchEsUserRequested,
  searchEsUserData: getSearchedEsUserData,
  applicationUpgradeRequested: getapplicationUpgradeRequested,
  upgradeInfo: getUpgradeInfo,
  overrideInfo: getOverrideInfo,
  evaluatedInfo: getEvaluatedInfo,
  isLoading: getIsLoading,
  isEsLoading: getIsEsLoading,
  coachDeleted: getDeletedCoach,
  coachAdded: getCoachAdded,
  collegeModified: getCollegeModified,
  coachesFromCollege: getCoachesFromCollege,
  collegeAdded: getCollegeAdded,
  searchHappened: getSearchHappened,
  searchEsHappened: getSearchEsHappened,
  error,
  esError,
  filterBasedStudents,
  // filterBasedEsStudents,
  dashboardReset: getDashboardReset,
});



// WEBPACK FOOTER //
// ./src/containers/Admin/redux.js